import React from 'react';
import { Route, Routes } from 'react-router-dom';

import FreecodeTestInspectPage from 'pages/FreecodeTestInspect/FreecodeTestInspect';
import FreecodeChallengePage from 'pages/FreecodeChallenge/FreecodeChallenge';
import FreecodeTestTrialPage from 'pages/FreecodeTestTrial/FreecodeTestTrial';
import FreecodeExercisePage from 'pages/FreecodeExercise/FreecodeExercise';
import FreecodeCreatorPage from 'pages/FreecodeCreator/FreecodeCreator';
import FreecodeTestPage from 'pages/FreecodeTest/FreecodeTest';
import FreecodeCreatorInspect from 'pages/FreecodeCreatorInspect/FreecodeCreatorInspect';
import FreecodeLiveCoding from 'pages/FreecodeLiveCoding/FreecodeLiveCoding';
import CandidateFeedbackPage from 'pages/CandidateFeedbackPage/CandidateFeedbackPage';
import CodeChallenge from 'pages/CodeChallenge/CodeChallenge';
import MultichoiceTestPage from 'pages/MultichoiceTestPage/MultichoiceTestPage';
import CommunityListPage from 'pages/CommunityListPage/CommunityListPage';
import ResetPasswordPage from 'pages/ResetPasswordPage/ResetPasswordPage';
import AchievementsPage from 'pages/AchievementsPage/AchievementPage';
import CustomTestsPage from 'pages/CustomTestsPage/CustomTestsPage';
import SetPasswordPage from 'pages/SetPasswordPage/SetPasswordPage';
import CompanyPage from 'pages/CompanyPage/CompanyPage';
import CompanyEventsPage from 'pages/CompanyEventsPage/CompanyEventsPage';
import CommunitySelectedPage from 'pages/CommunitySelectedPage/CommunitySelectedPage';
import MembershipPage from 'pages/MembershipPage/MembershipPage';
import RedirectPage from 'pages/RedirectPage/RedirectPage';
import NotFoundPage from 'pages/NotFoundPage/NotFoundPage';
import ProfilePage from 'pages/ProfilePage';
import Landing from 'pages/Landing/Landing';
import CookiesPage from 'pages/CookiesPage/CookiesPage';
import ContactPage from 'pages/ContactPage/ContactPage';
import Statistics from 'pages/StatisticsPage';
import PolicyPage from 'pages/PolicyPage';
import SignupPage from 'pages/SignupPage/SignupPage';
import LoginPage from 'pages/LoginPage/LoginPage';
import AboutPage from 'pages/AboutPage/AboutPage';
import Hackathon from 'pages/Hackathon/Hackathon';
import HackathonMatches from 'pages/HackathonMatches/HackathonMatches';
import PaymentsPage from 'pages/PaymentsPage/PaymentsPage';
import FAQPage from 'pages/FAQPage/FAQPage';
import CandidateTicketsPage from 'pages/CandidateTicketsPage/CandidateTicketsPage';
import TicketSessionPage from 'pages/TicketSessionPage/TicketSessionPage';
import SettingsPage from 'pages/SettingsPage/SettingsPage';
import SuperAdminPage from 'pages/SuperAdminPage/SuperAdminPage';
import DepartmentSettingsPage from 'pages/SettingsPage/DepartmentSettingsPage';
import ReportPage from 'pages/ReportPage/ReportPage';
import CodeComparisonPage from 'pages/CodeComparisonPage/CodeComparisonPage';
import XPPage from 'pages/XPPage/XPPage';
import QuestionFeedbackPage from 'pages/QuestionFeedbackPage/QuestionFeedback';
import SendTestPage from 'pages/SendTestPage/SendTestPage';
import UnsubscribePage from 'pages/UnsubscribePage/UnsubscribePage';
import TicketsPage from 'pages/TicketsPage/TicketsPage';
import Contest from 'pages/cmsEditContest/cmsEditContest';
import Result from 'pages/cmsResult/cmsResult';
import CandidateInfo from 'pages/cmsCandidateInfo/cmsCandidateInfo';
import AllContests from 'pages/cmsAllContests/cmsAllContests';
import AllChallenges from 'pages/cmsAllChallenges/cmsAllChallenges';
import PlansPage from 'pages/PlansPage/PlansPage';
import StripeResponsePage from 'pages/PlansPage/StripeResponsePage';
import CommunityEmailPage from 'pages/CommunityEmailPage/CommunityEmailPage';
import MultichoiceCreator from 'pages/MultichoiceCreator/MultichoiceCreator';
import GDPRDeletionPage from 'pages/GDPRDeletionPage/GDPRDeletionPage';
import GDPRConfirmationPage from 'pages/GDPRConfirmationPage/GDPRConfirmationPage';
import BlackFridayPage from 'pages/BlackFridayPage/BlackFridayPage';
import SchoolLandingPage from 'pages/SchoolLandingPage/SchoolLandingPage';
import CourseStripeResponsePage from 'pages/CommunitySelectedPage/CourseStripeResponsePage';
import CoursePage from 'pages/CoursePage/CoursePage';

import FreecodeRoute from './FreecodeRoute';
import CommunityRoute from './CommunityRoute';
import CompanyRoute from './CompanyRoute';
import Path from './Path';
import App from '../App';

export const Router = () => {
  return (
    <App>
      <Routes>
        {/* Header-less routes */}
        <Route path={Path.hackathon} element={<Hackathon />} />
        <Route path={Path.hackathonMatches} element={<HackathonMatches />} />

        {/* Community Routes */}
        <Route path={Path.defaultHandler} element={<CommunityRoute component={NotFoundPage} />} />
        <Route path={Path.notFoundPage} element={<CommunityRoute component={NotFoundPage} />} />
        <Route path={Path.landingPage} element={<CommunityRoute component={Landing} />} />
        <Route path={Path.companyPage} element={<CommunityRoute component={CompanyPage} zendesk="open" />} />
        <Route path={Path.companyEventsPage} element={<CommunityRoute component={CompanyEventsPage} />} />
        <Route path={Path.codeChallenge} element={<CommunityRoute component={CodeChallenge} />} />
        <Route path={Path.membershipPage} element={<CommunityRoute component={MembershipPage} />} />
        <Route path={Path.cookiesPage} element={<CommunityRoute component={CookiesPage} />} />
        <Route path={Path.contactPage} element={<CommunityRoute component={ContactPage} zendesk="open" />} />
        <Route path={Path.policyPage} element={<CommunityRoute component={PolicyPage} />} />
        <Route path={Path.aboutPage} element={<CommunityRoute component={AboutPage} zendesk="open" />} />
        <Route path={Path.faqPage} element={<CommunityRoute component={FAQPage} />} />
        <Route path={Path.redirect} element={<CommunityRoute component={RedirectPage} />} />
        <Route path={Path.unsubscribe} element={<CommunityRoute component={UnsubscribePage} />} />
        <Route path={Path.loginPage} element={<CommunityRoute component={LoginPage} authMode="unauthed" />} />
        <Route path={Path.signupPage} element={<CommunityRoute component={SignupPage} authMode="unauthed" />} />
        <Route
          path={Path.resetPasswordPage}
          element={<CommunityRoute component={ResetPasswordPage} authMode="unauthed" />}
        />
        <Route
          path={Path.setPasswordPage}
          element={<CommunityRoute component={SetPasswordPage} authMode="unauthed" />}
        />
        <Route path={Path.courseListPage} element={<CommunityRoute component={CommunityListPage} />} />
        <Route path={Path.courseLandingPage} element={<CommunityRoute component={CoursePage} />} />
        <Route path={Path.exerciseListPage} element={<CommunityRoute component={CommunityListPage} />} />
        <Route path={Path.exerciseLandingPage} element={<CommunityRoute component={CommunitySelectedPage} />} />
        <Route path={Path.challengeListPage} element={<CommunityRoute component={CommunityListPage} />} />
        <Route path={Path.challengeLandingPage} element={<CommunityRoute component={CommunitySelectedPage} />} />
        <Route path={Path.profilePage} element={<CommunityRoute component={ProfilePage} authMode="private" />} />
        <Route
          path={Path.profileChallenges}
          element={<CommunityRoute component={ProfilePage} authMode="private" subpage="challenges" />}
        />
        <Route
          path={Path.profileExercises}
          element={<CommunityRoute component={ProfilePage} authMode="private" subpage="exercises" />}
        />
        <Route
          path={Path.profileFriends}
          element={<CommunityRoute component={ProfilePage} authMode="private" subpage="friends" />}
        />
        <Route
          path={Path.profileCourses}
          element={<CommunityRoute component={ProfilePage} authMode="private" subpage="courses" />}
        />
        <Route
          path={Path.achievementPage}
          element={<CommunityRoute component={AchievementsPage} authMode="private" />}
        />
        <Route path={Path.schoolLandingPage} element={<CommunityRoute component={SchoolLandingPage} />} />
        <Route path={Path.xpPage} element={<CommunityRoute component={XPPage} authMode="private" />} />
        <Route path={Path.GDPRDeletionPage} element={<CommunityRoute component={GDPRDeletionPage} />} />
        <Route path={Path.GDPRConfirmationPage} element={<CommunityRoute component={GDPRConfirmationPage} />} />
        <Route path={Path.blackFridayPage} element={<CommunityRoute component={BlackFridayPage} />} />
        <Route path={Path.courseStripeResponse} element={<CommunityRoute component={CourseStripeResponsePage} />} />

        {/* Company Routes */}
        <Route path={Path.customTests} element={<CompanyRoute component={CustomTestsPage} authMode="private" />} />
        <Route path={Path.statistics} element={<CompanyRoute component={Statistics} authMode="private" />} />
        <Route path={Path.settings} element={<CompanyRoute component={SettingsPage} authMode="private" />} />
        <Route path={Path.sendTestPage} element={<CompanyRoute component={SendTestPage} />} />
        <Route path={Path.payments} element={<CompanyRoute component={PaymentsPage} authMode="private" />} />
        <Route path={Path.report} element={<CompanyRoute component={ReportPage} />} />
        <Route path={Path.downloadReport} element={<CompanyRoute component={ReportPage} zendesk="hide" />} />
        <Route path={Path.anonymiseReport} element={<CompanyRoute component={ReportPage} />} />
        <Route path={Path.ticketSessionPage} element={<CompanyRoute component={TicketSessionPage} />} />
        <Route
          path={Path.candidateTicketsPage}
          element={<CompanyRoute component={CandidateTicketsPage} hideFooter />}
        />
        <Route path={Path.codeComparison} element={<CompanyRoute component={CodeComparisonPage} zendesk="hide" />} />
        <Route
          path={Path.superadmin}
          element={<CompanyRoute component={SuperAdminPage} authMode="private" zendesk="hide" />}
        />
        <Route
          path={Path.candidateFeedbackPage}
          element={<CompanyRoute component={CandidateFeedbackPage} authMode="private" />}
        />
        <Route
          path={Path.departmentSettings}
          element={<CompanyRoute component={DepartmentSettingsPage} authMode="private" />}
        />
        <Route
          path={Path.questionFeedbackPage}
          element={<CompanyRoute component={QuestionFeedbackPage} authMode="private" zendesk="hide" />}
        />
        <Route
          path={Path.multichoice}
          element={<CompanyRoute component={MultichoiceTestPage} hideFooter authMode="private" zendesk="hide" />}
        />
        <Route
          path={Path.testsPage}
          element={<CompanyRoute component={TicketsPage} authMode="private" zendesk="hide" />}
        />
        <Route path={Path.AllChallenges} element={<CompanyRoute component={AllChallenges} authMode="private" />} />
        <Route path={Path.contest} element={<CompanyRoute component={Contest} />} />
        <Route path={Path.allContest} element={<CompanyRoute component={AllContests} />} />
        <Route path={Path.result} element={<CompanyRoute component={Result} />} />
        <Route path={Path.candidateInfo} element={<CompanyRoute component={CandidateInfo} />} />
        <Route path={Path.handleStripeResponse} element={<CompanyRoute component={StripeResponsePage} />} />
        <Route path={Path.subscriptionPlans} element={<CompanyRoute component={PlansPage} />} />
        <Route path={Path.communityEmailPage} element={<CompanyRoute component={CommunityEmailPage} />} />
        <Route path={Path.multichoiceCreatorPage} element={<CompanyRoute component={MultichoiceCreator} />} />

        {/* Freecode Routes */}
        <Route path={Path.freecodeExercisePage} element={<FreecodeRoute component={FreecodeExercisePage} />} />
        <Route path={Path.freecodeChallengePage} element={<FreecodeRoute component={FreecodeChallengePage} />} />
        <Route path={Path.freecodeCreatorPage} element={<FreecodeRoute component={FreecodeCreatorPage} />} />
        <Route path={Path.freecodeTestTrialPage} element={<FreecodeRoute component={FreecodeTestTrialPage} />} />
        <Route path={Path.freecodeTestPage} element={<FreecodeRoute component={FreecodeTestPage} />} />
        <Route path={Path.freecodeTestInspectPage} element={<FreecodeRoute component={FreecodeTestInspectPage} />} />
        <Route path={Path.freecodeCreatorInspectPage} element={<FreecodeRoute component={FreecodeCreatorInspect} />} />
        <Route path={Path.freecodeLiveCodingPage} element={<FreecodeRoute component={FreecodeLiveCoding} />} />
      </Routes>
    </App>
  );
};
